<template lang="pug">
.card-coupons-container(v-show="needShowModule")
  .title 热门优惠券专区
  //- .tabs
  //-   .tab(
  //-     v-if="env.isEasyBikeApp && showAppOnly",
  //-     @click="changeTab(0)",
  //-     :class="[active === 0 ? 'active' : '']"
  //-   )
  //-     span 特惠卡券
  //-   .tab(
  //-     v-if="!env.isEasyBikeApp",
  //-     @click="changeTab(1)",
  //-     :class="[active === 1 ? 'active' : '']"
  //-   )
  //-     img(
  //-       :src="tabImg"
  //-     )
  //-   .tab(@click="changeTab(2)", :class="freeCouponsActiveStyle")
  //-     span 免费领券
  //- .tip(@click="goReceive")
  //-   .icon
  //-   .content
  //-     span 恭喜获得最高
  //-     i 200
  //-     span 元优惠礼包
  //-   .receive
  //-     span 立即领取
  template(v-if="preparing")
    .shadow-cards
      .shadow-cards-item
      .shadow-cards-item
      .shadow-cards-item
  .body(v-show="!preparing")
    AppOnlyCard(
      ref="tab0",
      v-if="env.isEasyBikeApp && showAppOnly"
      v-show="active === 0",
      @coupon="$emit('coupon')",
      @tab="handleTab",
      @showModule="showModule"
    )
    TimeCoupons(
      v-if="showTimeCoupon"
      ref="tab1",
      v-show="active === 1",
      :activity="config.time",
      @coupon="$emit('coupon')"
      @showModule="showModule"
    )
    FreeCoupons(
      ref="tab2",
      v-show="active === 2",
      :activity="config.coupons",
      @coupon="$emit('coupon')"
    )
</template>

<script>
import { getCommonConfig } from '@/api/card';
import { env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import AppOnlyCard from './app-only-card';
import TimeCoupons from './time-coupons';
import FreeCoupons from './free-coupons';
import { getTokenAndKey } from '../../../utils';
import { FULI_MODULE } from '../consts';

export default {
  components: {
    AppOnlyCard,
    TimeCoupons,
    FreeCoupons,
  },
  props: {
    tab: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      active: 0,
      showAppOnly: true,
      preparing: true,
      config: {
        time: {},
        coupons: {},
      },
      env,
      isMP: false,
      needShowModule: false,
      showTimeCoupon: true,
    };
  },
  computed: {
    tabImg() {
      return this.active === 1
        ? 'https://m.hellobike.com/resource/AppPlatformH5/fuli/5Kb8eV0pD3s8LS67VzcsH.png'
        : 'https://m.hellobike.com/resource/AppPlatformH5/fuli/uOYW41mRR_N_a53_CnL3J.png';
    },
    freeCouponsActiveStyle() {
      // 区分app和小程序不选择状态
      if (this.active === 2) {
        return 'active';
      }
      if (this.isMP) {
        return 'clear';
      }
      return '';


      // return this.active === 2 ? 'active' : (this.isMP ? 'clear' : '');
    },
  },
  watch: {
    tab(v) {
      if (typeof v === 'number' || typeof v === 'string') {
        this.active = Number(v);
      }
    },
  },
  created() {
    const { tab, to } = this.$route.query;
    if (to === FULI_MODULE.welfare_cardAndCoupon && tab !== undefined) {
      this.active = Number(tab);
    } else {
      this.active = env.isEasyBikeApp ? 0 : 1;
    }

    if (env.isAliMP || env.isAliMPMonitor) {
      this.isMP = true;
    }
  },
  methods: {
    handleTab(showAppOnly) {
      if (!showAppOnly) {
        this.showAppOnly = showAppOnly;
        this.active = env.isEasyBikeApp ? 2 : 1;
      }
    },
    changeTab(index) {
      this.active = index;
      if (index === 2) {
        UBT.clickButton({
          pageId: 'Welfare',
          buttonName: 'receive_coupon',
          categoryId: 'platform',
          businessInfo: {},
        });
      }
      if (index === 1) {
        UBT.clickButton({
          pageId: 'Welfare',
          buttonName: 'platform_Scramble',
          categoryId: 'platform',
          businessInfo: {
            businessType: '1',
          },
        });
      }
      if (index === 0) {
        UBT.clickButton({
          pageId: 'Welfare',
          buttonName: 'platform_Scramble',
          categoryId: 'platform',
          businessInfo: {
            businessType: '0',
          },
        });
      }
    },
    async start() {
      const { token } = await getTokenAndKey();
      const { welfare } = await getCommonConfig({ token })
        .then((v) => v.data || {})
        .catch(() => ({}));
      if (!welfare) {
        return Promise.resolve();
      }
      this.config = welfare;
      this.preparing = false;
      this.showModule(true);
      return Promise.all([
        [0, 1, 2].reduce((res, v) => {
          if (
            this.$refs[`tab${v}`]
            && typeof this.$refs[`tab${v}`].getData === 'function'
          ) {
            res.push(
              new Promise((resolve) => {
                this.$nextTick(() => {
                  this.$refs[`tab${v}`].getData().then(resolve);
                });
              }),
            );
          }
          return res;
        }, []),
      ]);
    },
    // goReceive() {
    //   // 优惠券tip跳转领券落地页点击埋点
    //   UBT.clickButton({
    //     pageId: 'Welfare',
    //     buttonName: 'platform_freecoupon',
    //     categoryId: 'platform',
    //     businessInfo: {},
    //   });
    //   this.$router.push({
    //     path: '/collect-coupons',
    //     query: {
    //       pageSrc: 'market',
    //     },
    //   });
    // },
    showModule(status) {
      this.needShowModule = status;
    },
    // showTime() {
    //   this.showTimeCoupon = false;
    // },
  },
};
</script>

<style lang="less" scoped>
.card-coupons-container {
  padding: 0.2rem 0.16rem 0.16rem;

  .shadow-cards-item {
    width: 100%;
    height: 0.71rem;
    background: #f7f9fa;
    border-radius: 0.04rem;

    &:not(:last-of-type) {
      margin-bottom: 0.08rem;
    }
  }

  .title {
    font-size: 0.18rem;
    color: #242729;
    margin-bottom: 0.14rem;
    font-weight: 500;
  }

  .tip {
    width: 100%;
    height: 0.4rem;
    background: rgba(255, 240, 218, 0.4);
    border-radius: 0.04rem;
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 0.16rem;

    .icon {
      width: 0.16rem;
      height: 0.2rem;
      background: url('https://m.hellobike.com/resource/helloyun/wb15250/mpSZI9jCuc.png?x-oss-process=image/quality,q_80') no-repeat top;
      background-size: 100% 100%;
      margin-left: 0.12rem;
      margin-right: 0.12rem;
    }

    .content {
      max-width: 1.95rem;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 0.12rem;
      color: #000;

      i {
        font-style: normal;
        font-size: 0.14rem;
        font-weight: bold;
        font-family: "DIN Alternate Bold", sans-serif;
        color: #f72626;
      }
    }

    .receive {
      position: absolute;
      top: 0.12rem;
      left: 2.49rem;
      font-size: 0.12rem;
      font-weight: 400;
      color: #242729;

      &::after {
        content: "";
        display: inline-block;
        width: 0.1rem;
        height: 0.1rem;
        background: url('https://m.hellobike.com/resource/helloyun/wb15250/7B0hf-sbl0.png?x-oss-process=image/quality,q_80') no-repeat top;
        background-size: 100% 100%;
      }
    }
  }

  .tabs {
    display: flex;
    font-size: 0.14rem;
    font-weight: 500;
    color: #242729;
    position: relative;
    margin-bottom: 0.2rem;

    .tab {
      width: 0.56rem;
      display: flex;
      align-items: center;
      position: relative;

      &:not(:first-of-type) {
        margin-left: 0.32rem;
      }

      span {
        white-space: nowrap;
      }

      img {
        width: 100%;
      }

      &::after {
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -0.04rem;
        width: 0;
        height: 0.02rem;
        background: #08f;
        border-radius: 0.02rem;
        transition: width 0.2s ease-in-out;
      }

      &.active::after {
        width: 0.18rem;
      }
    }

    .clear {
      color: #879099;
      font-weight: 400;
    }

    .hover-bar {
      width: 0.18rem;
      height: 0.02rem;
      background: #08f;
      border-radius: 0.02rem;
      position: absolute;
      left: 0.16rem;
      top: 0.2rem;
      transition: transform 200ms ease-in-out;
    }
  }
}
</style>
